<!-- @format -->

<member-tag>
  <div class="contents contents-wide">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">メンバー管理</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item"><a href="/" class="home">ホーム</a></li>
          <li class="breadcrumb-item">メンバー管理</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="lead_block">
        <p>
          管理者、マネージャーの権限を持っているメンバーは、EDITECH
          HUBのメンバー追加や、各種サービスの利用制限を設定することが可能です。
          <br />
          設定できる権限などの詳細は
          <a href="/menu/about-role">こちら</a>
          でご確認ください。
        </p>
      </div>
      <!--/.lead_block-->

      <div class="container_input">
        <button
          class="button button-modal button-modal-invite js-modal-open"
          type="button"
          onclick="{ e => update({addModalIsOpen: true}) }"
        >
          メンバーを招待
        </button>
        <p>
          &nbsp;&nbsp;（招待中：
          <strong>{ state.invitations.length }</strong>
          名）
        </p>
      </div>
      <!--/.container_input-->

      <div class="contents_block table">
        <table class="contents_table membership">
          <tbody>
            <tr class="column_membership">
              <th class="group">部署名/所属グループ名</th>
              <th class="name">名前</th>
              <th class="role">権限</th>
              <th class="service">利用可能サービス/ 権限</th>
              <th class="edit"></th>
            </tr>
            <tr
              class="row_membership"
              each="{ (member, index) in state.members}"
            >
              <td class="group">{ member.user_info.group_name }</td>
              <td class="name">
                <div class="user-account_name">
                  <div class="user-account_name-icon">
                    <img
                      if="{ member.user_info.icon_path }"
                      src="{ member.user_info.icon_path }"
                      alt=""
                    />
                    <img
                      if="{ !member.user_info.icon_path }"
                      src="/assets/img/icon_default.svg"
                      alt=""
                    />
                  </div>
                  <p class="user">{ member.name }</p>
                </div>
              </td>
              <td class="role">{ Role.get(member.role).name }</td>
              <td class="service">
                <ul class="unordered_list01">
                  <li
                    class="unordered_list01-item"
                    each="{ service in Object.values(member.services) }"
                  >
                    {service.service_name} / {Role.get(service.role_id).name}
                  </li>
                </ul>
              </td>
              <td class="edit">
                <div class="container_button-edit">
                  <button
                    class="button button-clear-mini js-modal-open"
                    type="button"
                    value="削除"
                    data-target="modal-member_clear-01"
                    onclick="{ e => update({ delModalIsOpen: true, modalMember: member }) }"
                  >
                    削除
                  </button>
                  <button
                    class="button button-secondary-mini js-modal-open"
                    type="button"
                    value="編集"
                    data-target="modal-member_edit-01"
                    onclick="{ e => update({ editModalIsOpen: true, modalMember: member }) }"
                  >
                    編集
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!--/.contents_table-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <member-del-modal
    member="{ state.modalMember }"
    is-open="{ state.delModalIsOpen }"
    on-close="{ e => update({delModalIsOpen: false}) }"
    on-delete="{ onDelete }"
  ></member-del-modal>

  <member-add-modal
    is-open="{ state.addModalIsOpen }"
    on-close="{ e => update({addModalIsOpen: false}) }"
    on-add="{ onAdd }"
    error-message="{ state.addError }"
  ></member-add-modal>

  <member-edit-modal
    is-open="{ state.editModalIsOpen }"
    on-close="{ e => update({editModalIsOpen: false}) }"
    on-update-member="{ onUpdateMember }"
    member="{ state.modalMember }"
  ></member-edit-modal>

  <script>
    import di from "dependeny-injection";
    import memberDelModal from "@tags/modal/menu/member-del-modal.riot";
    import memberAddModal from "@tags/modal/menu/member-add-modal.riot";
    import memberEditModal from "@tags/modal/menu/member-edit-modal.riot";
    import Role from "@model/role.js";

    export default {
      MenuApi: false,
      state: {
        invitations: [],
        members: [],
        isLoading: true,
        addModalIsOpen: false,
        delModalIsOpen: false,
        editModalIsOpen: false,
        addError: "",
        modalMember: {},
      },
      components: {
        "member-del-modal": memberDelModal,
        "member-add-modal": memberAddModal,
        "member-edit-modal": memberEditModal,
      },
      fetchInvitation() {
        this.MenuApi.request("member", "invitations").then((data) =>
          this.onInvitationUpdate(data)
        );
      },
      fetchMember() {
        this.MenuApi.request("member", "fetch").then((data) =>
          this.onMembersUpdate(data)
        );
      },
      onInvitationUpdate(data) {
        this.update({ invitations: data });
      },
      onMembersUpdate(data) {
        this.update({ members: data });
      },
      onBeforeMount() {
        this.Role = Role;
        this.MenuApi = di.createApi();
        this.fetchInvitation();
        this.fetchMember();
      },
      onAdd(e, mail, role) {
        this.MenuApi.request("member", "invite", { mail, role })
          .then((data) => {
            di.toast.push(`メンバー招待をしました`, "success");
            this.fetchInvitation();
            this.update({ addModalIsOpen: false });
          })
          .catch((err) => {
            this.update({ addError: err.message });
            di.toast.push(err.message, "negative");
          });
      },
      onUpdateMember(param) {
        this.MenuApi.request("member", "change", param).then((data) => {
          this.fetchMember();
          this.update({ editModalIsOpen: false });
        });
      },
      onDelete(e, member) {
        if (!confirm(`本当に${member.name}をメンバーから削除しますか？`)) {
          return;
        }
        this.MenuApi.request("member", "delete", {
          id: member.id,
        }).then((data) => {
          this.fetchMember();
          this.update({ delModalIsOpen: false });
        });
      },
    };
  </script>
</member-tag>
